import { cn } from '@/lib/utils';
import type { CellData } from './types';

interface CellRendererProps {
  cell: CellData;
}

export function CellRenderer({ cell }: CellRendererProps) {
  if (cell.value === null || cell.value === '') {
    return <span className="text-muted-foreground/30">&nbsp;</span>;
  }

  const isNumber = cell.type === 'number';
  const format = cell.format;

  return (
    <span
      className={cn(
        isNumber && 'tabular-nums',
        format?.bold && 'font-bold',
        format?.italic && 'italic',
      )}
      style={{
        color: format?.textColor,
        backgroundColor: format?.bgColor,
      }}
    >
      {cell.value}
    </span>
  );
}
